import { useMutation } from '@tanstack/react-query';
import bookingApi from '@/features/public/booking/api/bookingApi.ts';
import { BookingSpecificationRequest } from '@/features/public/booking/types/BookingSpecificationRequest.ts';
import { ConsentPreviewResponseDto } from '@/features/public/booking/types/ConsentPreviewResponseDto.ts';

interface PreviewConsentParams {
  orgSlug: string;
  tourSlug: string;
  consentId: string;
  bookingSpecification: BookingSpecificationRequest;
}

const usePreviewConsent = () => {
  return useMutation<ConsentPreviewResponseDto, Error, PreviewConsentParams>({
    mutationFn: ({ orgSlug, tourSlug, consentId, bookingSpecification }) =>
      bookingApi.previewConsent(
        orgSlug,
        tourSlug,
        consentId,
        bookingSpecification,
      ),
  });
};

export default usePreviewConsent;
